import type { PageContext } from '@zto/zpage'
import dayjs from 'dayjs'

export function logDialog() {
  return {
    width: 600,
    top: '10vh',
    labelWidth: 0,
    itemSpan: 24,

    onShow: async ({ app, data }: PageContext) => {
      const res = await app.request({
        api: '/cabinet/admin/base/AdminBaseCommonQueryController/queryAuditLogPage',
        params: { bizNo: data.templateCode, logScene: 'mkt.product_template_operate', current: 1, size: 100 }
      })

      return {
        payload: {
          operateLogData: res.data
        }
      }
    },

    formItems: [
      {
        label: '',
        labelWidth: 0,
        type: 'edit-table',
        prop: 'operateLogData',
        span: 24,
        // height: 300,
        noOperation: true,
        autoHeight: true,
        border: true,
        columns: [
          {
            label: '操作时间',
            minWidth: 150,
            formatter: (row: any) => {
              return row.gmtCreate ? dayjs(row.gmtCreate).format('YYYY-MM-DD HH:mm:ss') : '--'
            }
          },
          { prop: 'logDesc', label: '操作名称', minWidth: 160 },
          { prop: 'creator', label: '操作人', minWidth: 100 }
        ]
      }
    ],

    actions: {
      close: {}
    }
  }
}
